import gql from "graphql-tag"
import { CartFields, CustomerFields } from "./fragments"

export const GetCheckout = gql`
  ${CartFields}
  query GetCheckout($id: ID!) {
    cart(id: $id) {
      ...CartFields
    }
  }
`

export const GetCartSimple = gql`
  query GetCheckout($id: ID!) {
    cart(id: $id) {
      id
      note
      checkoutUrl
      updatedAt
      createdAt
      totalQuantity
      cost {
        subtotalAmount {
          ... on MoneyV2 {
            amount
            currencyCode
          }
        }
        totalAmount {
          ... on MoneyV2 {
            amount
            currencyCode
          }
        }
        totalTaxAmount {
          ... on MoneyV2 {
            amount
            currencyCode
          }
        }
      }
      lines(first: 100) {
        edges {
          node {
            id
            quantity
            merchandise {
              ... on ProductVariant {
                id
                availableForSale
                compareAtPrice {
                  ... on MoneyV2 {
                    amount
                    currencyCode
                  }
                }
                price {
                  ... on MoneyV2 {
                    amount
                    currencyCode
                  }
                }
                product {
                  ... on Product {
                    id
                  }
                }
                sku
              }
            }
            attributes {
              key
              value
            }
            cost {
              amountPerQuantity {
                ... on MoneyV2 {
                  amount
                  currencyCode
                }
              }
              subtotalAmount {
                ... on MoneyV2 {
                  amount
                  currencyCode
                }
              }
              totalAmount {
                ... on MoneyV2 {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GetCustomer = gql`
  ${CustomerFields}
  query GetCustomer($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      ...CustomerFields
    }
  }
`

export const GetProductById = gql`
  query getProductById($id: ID!) {
    product(id: $id) {
      title
      status
      totalVariants
    }
  }
`
